import { is } from 'date-fns/locale';
import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  address: string;
  area: string;
  city: string;
  postalcode: string;
  county: string;
  region: string;
  country: string;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.address = undefined;
    this.area = undefined;
    this.city = undefined;
    this.postalcode = undefined;
    this.county = undefined;
    this.region = undefined;
    this.country = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetQuery = gql`
  query getTaxoffices($limit: Int, $offset: Int, $order: String, $where: String) {
    getTaxoffices(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        address
        area
        city
        postalcode
        county
        region
        country
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getTaxofficeById($id: Int) {
    getTaxofficeById(id: $id) {
      id
      name
      address
      area
      city
      postalcode
      county
      region
      country
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addTaxoffice($data: TaxofficeInput) {
    addTaxoffice(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateTaxoffice($data: TaxofficeInput) {
    updateTaxoffice(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteTaxoffice($id: Int) {
    deleteTaxoffice(id: $id)
  }
`;
